// Client brand colors as the wizard edits them: rows of {token, hex}, where
// the token is what the color is FOR ("buttons", "headlines") and becomes
// the key the build team reads. The server stores {token: hex}, so a color
// with no name has nowhere to go — it used to be dropped silently on save
// (Edward's staging test 2026-10-29: a suggested color clicked in, saved,
// and gone). Now save stops and the row says what it needs.

// What a row still needs before it can be saved: 'name', 'hex', or null.
// A completely blank row (an unused "+ Add color") is simply skipped.
export function colorRowIssue(row) {
  const token = (row?.token || '').trim();
  const hex = (row?.hex || '').trim();
  if (!token && !hex) return null;
  if (!token) return 'name';
  if (!hex) return 'hex';
  return null;
}

// The {token: hex} map the server takes — complete rows only.
export function colorsPayload(rows) {
  const colors = {};
  (rows || []).forEach(r => {
    const token = (r.token || '').trim();
    const hex = (r.hex || '').trim();
    if (token && hex) colors[token] = hex;
  });
  return colors;
}

// Same comparison the wizard uses to tell a suggestion is already a row.
export const sameHex = (a, b) =>
  (a || '').trim().toUpperCase().replace(/^#?/, '#') === (b || '').trim().toUpperCase().replace(/^#?/, '#');
